import React, { Key, useMemo } from 'react';
import { GridFilterProps } from '../../filters';
import { TTableColumn } from '../../models';
import { Identifiable, ISelectFilterStore } from '@custis/common';
import { observer } from 'mobx-react';
import { FilterWrapper } from '../filter-popup';
import { SelectFilter } from '../select-filter';
import { uniqueId } from 'lodash';

interface Props<TItem extends Identifiable, TFilter, TSorting> extends GridFilterProps<Key[]> {
  column: TTableColumn<TItem, TFilter, TSorting>;
  store: ISelectFilterStore<number | string>;
  mode?: 'multiple' | 'single';
}

export const HeaderCellSelectFilter = observer(
  <TItem extends Identifiable, TFilter, TSorting>({
    store,
    onConfirm,
    onReset,
    column,
    mode,
    ...restProps
  }: Props<TItem, TFilter, TSorting>) => {
    const id = useMemo(() => column.id || uniqueId(), []);

    const onFind = (v?: Key[]) => {
      setTimeout(() => {
        onConfirm(v ?? store.selectedValues);
      }, 100);
    };
    const onClear = () => {
      store.selectedValues = [];
      onReset();
    };
    return (
      <FilterWrapper {...restProps} onConfirm={onFind} onReset={onClear}>
        <SelectFilter
          {...restProps}
          onReset={onClear}
          onConfirm={onFind}
          store={store}
          id={id}
          mode={mode}
          emptyOption={column.selectFilterEmptyOption}
          emptyLabel={column.selectFilterEmptyLabel}
        />
      </FilterWrapper>
    );
  },
);
